import HTTPClient from '../..'

export const deleteSavedBucketsApi = async (ids: string[]) => {
  const { data } = await HTTPClient.delete(`favorites/${ids.join(',')}`)
  return data
}
